import { __read } from 'tslib';
import * as React from 'react';
import { dateUtils } from 'uitk-react-calendar';
import { UitkFakeInput } from 'uitk-react-input';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { useLocalization } from '@shared-ui/localization-context';
var getEffectiveConsolidatedDateString = dateUtils.getEffectiveConsolidatedDateString,
  getEffectiveDateText = dateUtils.getEffectiveDateText;
var UitkDateSelectorInputs = function (props) {
  var l10n = useLocalization();
  var defaultInputLabel1 = l10n.formatText('dateSelector.startDate.label');
  var defaultInputLabel2 = l10n.formatText('dateSelector.endDate.label');
  var dialogId = props.dialogId,
    input1Stid = props.input1Stid,
    input2Stid = props.input2Stid,
    dateFormatOptions = props.dateFormatOptions,
    endDate = props.endDate,
    handleClickInput1 = props.handleClickInput1,
    handleClickInput2 = props.handleClickInput2,
    input1Ref = props.input1Ref,
    input2Ref = props.input2Ref,
    _a = props.inputIcon1,
    inputIcon1 = _a === void 0 ? 'today' : _a,
    _b = props.inputIcon2,
    inputIcon2 = _b === void 0 ? 'today' : _b,
    _c = props.inputLabel1,
    inputLabel1 = _c === void 0 ? defaultInputLabel1 : _c,
    _d = props.inputLabel2,
    inputLabel2 = _d === void 0 ? defaultInputLabel2 : _d,
    inputName1 = props.inputName1,
    inputName2 = props.inputName2,
    invalidInput1 = props.invalidInput1,
    invalidInput2 = props.invalidInput2,
    isSingleDateSelection = props.isSingleDateSelection,
    locale = props.locale,
    startDate = props.startDate,
    trailingText1 = props.trailingText1,
    trailingText2 = props.trailingText2,
    useSingleTrigger = props.useSingleTrigger,
    customInputValue1 = props.inputValue1,
    customInputValue2 = props.inputValue2;
  var firstInputDataStid = "uitk-date-selector-input1-".concat(input1Stid !== null && input1Stid !== void 0 ? input1Stid : dialogId);
  var secondInputDataStid = "uitk-date-selector-input2-".concat(input2Stid !== null && input2Stid !== void 0 ? input2Stid : dialogId);
  var isMultiInput = React.useMemo(function () {
    return !isSingleDateSelection && !useSingleTrigger;
  }, [isSingleDateSelection, useSingleTrigger]);
  var _e = __read(React.useMemo(function () {
      var input1 = useSingleTrigger ? getEffectiveConsolidatedDateString(startDate !== null && startDate !== void 0 ? startDate : '', endDate !== null && endDate !== void 0 ? endDate : '', locale, dateFormatOptions) : getEffectiveDateText(startDate, locale, dateFormatOptions);
      var input2 = getEffectiveDateText(endDate, locale, dateFormatOptions);
      return [input1, input2];
    }, [dateFormatOptions, endDate, locale, startDate, useSingleTrigger]), 2),
    inputValue1 = _e[0],
    inputValue2 = _e[1];
  var _f = __read(React.useMemo(function () {
      return [Math.random().toString(36).substring(7), Math.random().toString(36).substring(7)];
    }, []), 2),
    inputId1 = _f[0],
    inputId2 = _f[1];
  return React.createElement(UitkLayoutFlex, {
    direction: "row",
    space: "three"
  }, React.createElement(UitkLayoutFlexItem, {
    grow: 1,
    maxWidth: isMultiInput ? 'half_width' : 'full_width'
  }, React.createElement("div", null, React.createElement(UitkFakeInput, {
    "data-testid": firstInputDataStid,
    "data-stid": firstInputDataStid,
    domRef: input1Ref,
    icon: inputIcon1,
    id: inputId1,
    label: inputLabel1,
    name: inputName1,
    onClick: handleClickInput1,
    value: customInputValue1 !== null && customInputValue1 !== void 0 ? customInputValue1 : inputValue1,
    trailingText: trailingText1,
    invalid: invalidInput1,
    "aria-invalid": !!invalidInput1,
    "aria-describedby": "".concat(inputId1, "-error")
  }))), isMultiInput && React.createElement(UitkLayoutFlexItem, {
    grow: 1,
    maxWidth: "half_width"
  }, React.createElement("div", null, React.createElement(UitkFakeInput, {
    "data-testid": secondInputDataStid,
    "data-stid": secondInputDataStid,
    domRef: input2Ref,
    icon: inputIcon2,
    id: inputId2,
    label: inputLabel2,
    name: inputName2,
    onClick: handleClickInput2,
    value: customInputValue2 !== null && customInputValue2 !== void 0 ? customInputValue2 : inputValue2,
    trailingText: trailingText2,
    invalid: invalidInput2,
    "aria-invalid": !!invalidInput2,
    "aria-describedby": "".concat(inputId2, "-error")
  }))));
};
UitkDateSelectorInputs.displayName = 'UitkDateSelectorInputs';
export { UitkDateSelectorInputs };